"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var PeriodResource = /** @class */ (function (_super) {
    tslib_1.__extends(PeriodResource, _super);
    function PeriodResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PeriodResource.endpoint = '/periods';
    PeriodResource.MODEL_NAME = 'period';
    return PeriodResource;
}(base_1.default));
exports.default = PeriodResource;
//# sourceMappingURL=period.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/period.js
// module id = X9sF
// module chunks = 0